<template>
  <div class="container">
    <app-header title="高级VIP创客认证"/>
    <div class="all">
      <div class="hint">高级VIP创客认证信息</div>
      <div class="title">1.个人信息认证</div>
      <div class="row">
        <span class="name">姓名</span>
        <input class="value" v-model="row.name" placeholder="请填写姓名"/>
      </div>
      <div class="row">
        <span class="name">联系方式</span>
        <input class="value" v-model="row.relation" placeholder="请填写联系方式"/>
      </div>
      <div class="row">
        <span class="name">地址</span>
        <input class="value" v-model="row.address" placeholder="请填写具体地址"/>
      </div>
      <div class="row">
        <span class="name">证件号码</span>
        <input class="value" v-model="row.idnum" placeholder="请填写有效身份证号码"/>
      </div>
      <div class="title">2.公司信息认证<span style="color: red;">（个人认证可选填）</span></div>
      <div class="row">
        <span class="name">公司姓名</span>
        <input class="value" v-model="row.companyName" placeholder="请填写公司名称"/>
      </div>
      <div class="row">
        <span class="name">联系方式</span>
        <input class="value" v-model="row.contactWay" placeholder="请填写联系方式"/>
      </div>
      <div class="row">
        <span class="name">企业法人</span>
        <input class="value" v-model="row.legalPerson" placeholder="请填写企业法人名称"/>
      </div>
      <div class="row">
        <span class="name">主营业务</span>
        <input class="value" v-model="row.business" placeholder="请填写"/>
      </div>
      <div class="title">2.营业执照<span style="color: red;">（选填）</span></div>
      <van-uploader
        :max-count='1'
        :file-list="fileList"
        :after-read="afterRead"
        @delete='deleteImg'
      />
      <div class="submit" v-if="!isFee" @click="_saveShopDistributorEc">提交</div>
      <div class="submit" v-if="isFee" @click="_saveShopDistributorEc">提交</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Uploader } from 'vant'
import { saveShopDistributorEc } from '../../../api/mine/distribution.js'
import { querySysMakerSwitchPage, querySysMakerSwitchList,deleteSysMakerSwitch,enable,disable } from '@/api/mine/maker.js'
import { uploadimage } from '@/api/file.js'
Vue.use(Uploader)
export default {
  name: 'Index',
  data() {
    return {
      show: false,
      fileList: [],
      isFee : false,
      openFee : 0,
      radio: '',
      row: {
        name: '',
        relation: '',
        address: '',
        idnum: '',
        companyName: '',
        contactWay: '',
        legalPerson: '',
        business: '',
        licenseUrl: ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    onOversize(file) {
      console.log(file)
    },
    // 新增高级VIP创客个人认证
    _saveShopDistributorEc() {
      if (this.row.name == '') {
        this.$toast.fail('姓名不能为空')
        return
      }
      if (this.row.relation == '') {
        this.$toast.fail('联系方式不能为空')
        return
      }
      if (this.row.address == '') {
        this.$toast.fail('地址不能为空')
        return
      }
      if (this.row.idnum == '') {
        this.$toast.fail('证件号码不能为空')
        return
      }

      var user = localStorage.getItem('userInfo')
      if (!user) {
        this.$router.push({ path: '/login' })
        return;
      }
      user = JSON.parse(user)
      const params = {
        ...this.row,
        uid: user.id
      }
      if (!this.isFee) {
        saveShopDistributorEc(params).then((res) => {
          if (res.success) {
            this.$toast.success('提交成功')
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      } else {
        params['fee'] = this.openFee
        this.$router.push({
          path:'/mine/vip/attestation',
          query:params
        })
      }
    },
    // 上传成功后回调
    afterRead(file) {
      uploadimage(file.file).then((res) => {
        if (res.success) {
          this.fileList.push({ url: res.data })
          this.row.licenseUrl = res.data
        }
      })
    },
    // 删除图片
    deleteImg(e) {
      this.fileList.splice(0, 1)
    },
    //获取
    getList() {
      querySysMakerSwitchList({}).then(response => {
        for (var i = 0; i < response.data.length; i ++) {
          if (response.data[i].title == 'VIP创客收费标准') {
            this.isFee = true
            this.openFee = response.data[i].money
            break
          }
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
  .container{
    .all{
      padding: 12px;
      .hint{
        padding: 3px;
        font-size:26px;
        font-family:PingFang SC;
        font-weight:bold;
        line-height:39px;
        color:rgba(51,51,51,1);
        text-shadow:0px 2px 0px rgba(212,212,212,1);
        opacity:1;
      }
      .title{
        font-size:18px;
        font-family:PingFang SC;
        font-weight:bold;
        line-height:39px;
        margin-top: 10px;
        color:rgba(51,51,51,1);
        opacity:1;
      }
      .row{
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 50px;
        border-bottom: 1px solid #F3F3F3;
        .name{
          width:64px;
          line-height: 60px;
          margin-right: 15px;
        }
        .value{
          width:245px;
          height:40px;
          border:none;
          margin-left: 10px;
        }
      }
      .synopsis{
        width:90%;
        height:244px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(243,243,243,1);
        opacity:1;
        border-radius:6px;
        padding: 10px;
      }
      .deal{
        font-size:13px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:39px;
        color:rgba(93,98,130,1);
        opacity:1;
        margin-top: 25px;
      }
      .submit{
        width:98%;
        height:40px;
        background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
        opacity:1;
        border-radius:4px;
        margin-left: 1%;
        font-size:16px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:40px;
        text-align: center;
        color:rgba(255,255,255,1);
        margin-top: 60px;
        margin-bottom: 50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/distribution/index.vue